import axios from "../axios-auth";

export const binTypeService = {
    getBinTypeList,
    saveBinType,
    getBinTypeDetail,
    getAllBinType
};

function getBinTypeList(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.typeName) {
        params["name"] = searchParams.typeName;
    }
    if (searchParams.typeCode) {
        params["code"] = searchParams.typeCode;
    }
    return axios.get("/auth/bintypes", { params });
}

function saveBinType(bintype) {
    if (!bintype.id) {
        // new brand
        return axios.post("/auth/bintype", bintype);
    } else {
        // edit
        return axios.put("/auth/bintype", bintype);
    }
}

function getBinTypeDetail(id) {
    return axios.get("/auth/bintype/" + id);
}

function getAllBinType() {
    return axios.get("/auth/all-bintype");
}
